import { Box, Text, Flex, Spinner, Button } from '@chakra-ui/react';
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAuth } from "../../../../shared/providers/AuthProvider/AuthProvider";
import { useAppToast } from "../../../../hooks/useAppToast";

const ActivationPage = () => {
    const { activate, error, errorCode } = useAuth();
    const navigate = useNavigate();
    const { t } = useTranslation("default");
    const { key } = useParams();
    const [loading, setLoading] = useState(true);
    const [activated, setActivated] = useState(false);
    const [activationError, setActivationError] = useState(null);
    const toast = useAppToast();

    const activateAccount = async () => {
        setLoading(true);
        setActivationError(null);
        try {
            const res = await activate(key);
            if (res) {
                setActivated(true);
            } else {
                setActivationError(error || errorCode || t('activation.error'));
            }
        } catch (err) {
            setActivationError(t('activation.error'));
            toast({ title: t('request.error'), status: 'error', duration: 3000, isClosable: true });
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (key) {
            activateAccount();
        } else {
            setLoading(false);
            setActivationError(t('activation.missing_key'));
        }
    }, [key]);

    return (
        <Flex minH="100vh" align="center" justify="center" bg="#F3F3F3" px={4}>
            <Box textAlign="center" maxW="lg">
                {loading && (
                    <>
                        <Spinner size="xl" color="#089A7A" mb={4} />
                        <Text fontSize="lg">{t('activation.loading')}</Text>
                    </>
                )}

                {!loading && activated && (
                    <>
                        <Text fontSize="2xl" fontWeight="bold" mb={4} color="#089A7A">
                            {t('activation.title')}
                        </Text>
                        <Text fontSize="lg" mb={6}>
                            {t('activation.message')}
                        </Text>
                        <Button
                            bg="#089A7A"
                            color="white"
                            _hover={{ bg: "#1A7743" }}
                            onClick={() => navigate('/login')}
                        >
                            {t('login.button')}
                        </Button>
                    </>
                )}

                {!loading && !activated && (
                    <>
                        <Text fontSize="2xl" fontWeight="bold" mb={4} color="red.500">
                            {t('activation.error_title')}
                        </Text>
                        <Text fontSize="lg" mb={6} color="gray.600">
                            {activationError || t('activation.error')}
                        </Text>
                        <Button
                            bg="#089A7A"
                            color="white"
                            _hover={{ bg: "#1A7743" }}
                            onClick={() => navigate('/login')}
                        >
                            {t('login.button')}
                        </Button>
                    </>
                )}
            </Box>
        </Flex>
    );
};

export default ActivationPage;
